export default __webpack_public_path__ + "static/DSC_0137-ff66992c64fbe0a057400e3b29c55c6f.jpg";